export default __webpack_public_path__ + "static/media/profile-photo-1000.f1d4f24b.webp";